import { combineReducers } from 'redux';
import { 
// System User Info
USER_DATA, USER_MENUS, USER_INFO, APPLICATION_CODES, TASK_ITEM, } from './types';
var userData = function (state, action) {
    if (state === void 0) { state = {
        userId: window.sessionStorage.getItem('userId') || '',
        userName: window.sessionStorage.getItem('username') || '',
    }; }
    var payload = action.payload, type = action.type;
    switch (type) {
        case USER_DATA:
            return payload;
        default:
            return state;
    }
};
var userMenus = function (state, action) {
    if (state === void 0) { state = []; }
    var payload = action.payload, type = action.type;
    switch (type) {
        case USER_MENUS:
            return payload;
        default:
            return state;
    }
};
var applicationCodes = function (state, action) {
    if (state === void 0) { state = []; }
    var payload = action.payload, type = action.type;
    switch (type) {
        case APPLICATION_CODES:
            return payload;
        default:
            return state;
    }
};
var userInfo = function (state, action) {
    if (state === void 0) { state = {}; }
    var payload = action.payload, type = action.type;
    switch (type) {
        case USER_INFO:
            return payload;
        default:
            return state;
    }
};
var taskItem = function (state, action) {
    if (state === void 0) { state = {
        taskId: '',
        taskName: '',
        urlPath: '',
    }; }
    var payload = action.payload, type = action.type;
    switch (type) {
        case TASK_ITEM:
            return payload;
        default:
            return state;
    }
};
export var SCOPE_NAME = 'LOGIN';
var LOGIN = combineReducers({
    userData: userData,
    applicationCodes: applicationCodes,
    userMenus: userMenus,
    userInfo: userInfo,
    taskItem: taskItem,
});
export default LOGIN;
